import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Dialog from "./Dialog";
import Title from "./Title";
import Footer from "./Footer";
var propTypes = {
  /** Can accept any JSX */
  dialogTitle: PropTypes.node,

  /** Can accept any JSX */
  body: PropTypes.node,

  /** Can accept any JSX, meant for dismiss + accept buttons */
  footer: PropTypes.node,
  theme: PropTypes.shape({
    dialogAlert: PropTypes.oneOf(['dark'])
  })
};
var defaultProps = {
  theme: {}
};
export function DialogAlert(_ref) {
  var dialogTitle = _ref.dialogTitle,
      body = _ref.body,
      footer = _ref.footer,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["dialogTitle", "body", "footer", "theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Dialog, props, React.createElement("header", null, React.createElement(Title, null, dialogTitle)), body, React.createElement(Footer, null, footer)));
}
DialogAlert.propTypes = propTypes;
DialogAlert.defaultProps = defaultProps;
DialogAlert.darkTheme = {
  dialogAlert: 'dark'
};
export default DialogAlert;